import { connect } from "react-redux";
import { compose } from "recompose";
import ToolkitListItem from "./ToolkitListItem";
import { VariantStateSlice, selectVariant } from "src/pods/variant";
import {
  READ_ALONGS,
  BEDTIME_STORIES,
  TABLE_TOPICS,
  MUSIC,
  MINDFULNESS,
  BRUSH_TEETH,
  SHAKE_SILLIES,
  WHOSE_TURN,
} from "utils/beyondToolkitTools";

function mapStateToProps(state: VariantStateSlice) {
  return {
    variant: selectVariant(state),
  };
}

type BedtimeListProps = {
  variant?: string | string[];
  isPremiumUnlocked: boolean;
  lockedUrl: string;
};

function BedtimeList(props: React.PropsWithChildren<BedtimeListProps>) {
  const bedtimeToolsList = [
    READ_ALONGS(),
    BRUSH_TEETH(),
    SHAKE_SILLIES(),
    WHOSE_TURN(),
    BEDTIME_STORIES(),
    TABLE_TOPICS(),
    MUSIC(),
    MINDFULNESS(),
  ];

  return (
    <div sx={{ width: "100%" }}>
      {bedtimeToolsList.map((tool) => {
        return (
          <ToolkitListItem
            key={tool.title}
            size="large"
            {...tool}
            isLocked={!tool.unlocked && !props.isPremiumUnlocked}
            lockedUrl={props.lockedUrl}
          />
        );
      })}
    </div>
  );
}

export default compose<BedtimeListProps, BedtimeListProps>(connect(mapStateToProps))(BedtimeList);
